import React from 'react';
import { motion } from 'framer-motion';
import { FiPlay, FiArrowRight } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  const visualVariants = {
    hidden: { opacity: 0, scale: 0.8, x: 50 },
    visible: {
      opacity: 1,
      scale: 1,
      x: 0,
      transition: {
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="hero-wrapper">
        <motion.div
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="hero-badge" variants={itemVariants}>
            <div className="badge-logo-wrapper">
              <img src="https://images-ext-1.discordapp.net/external/7p2Twn8BR9eluWU4rdtKpFfI3Pa211j_a9yjiEBX0Pc/%3Fsize%3D2048/https/cdn.discordapp.com/avatars/1329191092729417800/a_f65fc9a9da62aa5b35461d4d6a92a3bf.gif" alt="CSG TV Logo" className="badge-logo" />
            </div>
          </motion.div>

          <motion.h1 className="hero-title" variants={itemVariants}>

            <span className="gradient-text-iptv">CSG</span>
            <span className="gradient-text-premium"> TV</span>

          </motion.h1>

          <motion.p className="hero-description" variants={itemVariants}>
            Assista milhares de canais em alta qualidade, filmes, séries e eventos esportivos
            ao vivo. Disponível em todos os seus dispositivos favoritos.
          </motion.p>

          <motion.div className="hero-buttons" variants={itemVariants}>
            <motion.a
              href="#downloads"
              className="btn btn-primary"
              whileHover={{ scale: 1.05, boxShadow: '0 10px 40px rgba(0, 197, 70, 0.4)' }}
              whileTap={{ scale: 0.95 }}
            >
              <span>Baixar Agora</span>
              <FiArrowRight />
            </motion.a>
            <motion.a
              href="https://youtu.be/PiEg_x8crVM?si"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
              whileHover={{ scale: 1.05, borderColor: 'rgba(0, 197, 70, 0.5)' }}
              whileTap={{ scale: 0.95 }}
            >
              <FiPlay />
              <span>Ver demonstração</span>
            </motion.a>
          </motion.div>

          <motion.div className="hero-stats" variants={itemVariants}>
            <div className="stat-item">
              <div className="stat-number">10K+</div>
              <div className="stat-label">Canais</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5K+</div>
              <div className="stat-label">Usuários</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">99.9%</div>
              <div className="stat-label">Uptime</div>
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          className="hero-visual"
          variants={visualVariants}
          initial="hidden"
          animate="visible"
        >
          <div className="hero-image-container">
            <motion.iframe
              src="https://www.youtube.com/embed/PiEg_x8crVM?autoplay=0&controls=1&rel=0"
              title="CSG TV Demo"
              className="hero-image"
              style={{ 
                aspectRatio: '16/9',
                border: 'none',
                borderRadius: '12px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)'
              }}
              animate={{ 
                y: [0, -20, 0],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
            <div className="hero-image-glow"></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
